module.exports = __webpack_public_path__ + "static/media/zacard.3a70561d.jpg";